/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React from "react";
import { useGLTF } from "@react-three/drei";

export default function Model(props) {
  const { nodes, materials } = useGLTF("/entryScene.glb");

  return (
    <group {...props} dispose={null}>
      <group name="Scene">
        <mesh
          name="Floor-AboutMe"
          castShadow
          receiveShadow
          geometry={nodes["Floor-AboutMe"].geometry}
          material={materials["Wood OldFence"]}
          position={[-8.04206848, -1.6781857, 43.79442978]}
          scale={0.175704}
          userData={{ name: "Floor-AboutMe" }}
        />
        <mesh
          name="Screen_Projects_Overview"
          castShadow
          receiveShadow
          geometry={nodes.Screen_Projects_Overview.geometry}
          material={materials["Glowy Material"]}
          position={[-1.00874233, 3.34694862, 8.48687363]}
          rotation={[Math.PI / 2, 0, 0]}
          scale={[3.01130247, 1, 3.33457279]}
          userData={{ name: "Screen Projects Overview" }}
        ></mesh>
        <group
          name="baked"
          position={[3.70990849, 0, -7.27876568]}
          rotation={[0, 0.14086066, 0]}
          scale={5.04096746}
          userData={{ name: "baked" }}
        >
          <mesh
            name="Cube001"
            castShadow
            receiveShadow
            geometry={nodes.Cube001.geometry}
            material={materials.Sand}
          />
          <mesh
            name="Cube001_1"
            castShadow
            receiveShadow
            geometry={nodes.Cube001_1.geometry}
            material={materials["Wooden Burnt"]}
          />
          <mesh
            name="Cube001_2"
            castShadow
            receiveShadow
            geometry={nodes.Cube001_2.geometry}
            material={materials["Wood OldFence"]}
          />
          <mesh
            name="Cube001_3"
            castShadow
            receiveShadow
            geometry={nodes.Cube001_3.geometry}
            material={materials["Wood OldFence"]}
          />
          <mesh
            name="Cube001_4"
            castShadow
            receiveShadow
            geometry={nodes.Cube001_4.geometry}
            material={materials["Glowy floor"]}
          />
        </group>
        <group
          name="Bar"
          position={[-13.46819496, -0.14491485, 39.60429382]}
          scale={[0.09505855, 1, 0.20304906]}
          userData={{ name: "Bar" }}
        >
          <mesh
            name="Cube004"
            castShadow
            receiveShadow
            geometry={nodes.Cube004.geometry}
            material={materials["Wood Mahoghany"]}
          />
          <mesh
            name="Cube004_1"
            castShadow
            receiveShadow
            geometry={nodes.Cube004_1.geometry}
            material={materials["Wood OldFence"]}
          />
          <mesh
            name="Cube004_2"
            castShadow
            receiveShadow
            geometry={nodes.Cube004_2.geometry}
            material={materials["Glowy Roof"]}
          />
        </group>
      </group>
    </group>
  );
}

useGLTF.preload("/entryScene.glb");
